<div class="d-sm-flex align-items-center justify-content-between mb-4" style="margin-bottom: 0.5rem !important;">

  <h1 class="h3 mb-0 text-gray-800">{{ heading }}</h1>

  <ng-content></ng-content>
</div>
